import { common } from "../common/index.mjs.mjs";
import { colors } from "./audi-colors.mjs.mjs";
import { shadow } from "./audi-shadows.mjs.mjs";
export const audiLightTheme = {
    ...common,
    name: 'Audi Light Theme',
    colors,
    shadow,
};
//# sourceMappingURL=audi-light.theme.mjs.mjs.map